import { AxiosError } from 'axios'

import { client } from './client'
import * as ENDPOINTS from './endpoints'

interface LogoutResponseType {
  detail: string
}

export interface LogoutResultType {
  result: boolean
}

type EmptyJsonBody = JSON & Record<string, never>

export const logout = async (): Promise<LogoutResultType> => {
  try {
    const response = await client.post<LogoutResponseType, EmptyJsonBody>(
      ENDPOINTS.LOGOUT,
      {} as EmptyJsonBody
    )

    if (response.status === 200) {
      return { result: true }
    } else {
      return { result: false }
    }
  } catch (error) {
    if (error instanceof AxiosError) {
      console.error('Logout error:', error.message)
    } else {
      console.error('Unexpected error during logout:', error)
    }
    return { result: false }
  }
}
